
export default {
  weekDayNames: Object.freeze([
    { id: 0, value: 0, letter: "L", short: "Lun", text: "Lunes" },
    { id: 0, value: 0, letter: "M", short: "Mar", text: "Martes" },
    { id: 0, value: 0, letter: "X", short: "Mie", text: "Miércoles" },
    { id: 0, value: 0, letter: "J", short: "Jue", text: "Jueves" },
    { id: 0, value: 0, letter: "V", short: "Vie", text: "Viernes" },
    { id: 0, value: 0, letter: "S", short: "Sab", text: "Sábado" },
    { id: 0, value: 0, letter: "D", short: "Dom", text: "Domingo" },
  ]),

  openCloseTimes: Object.freeze([
    { id: 0, value: 0, text: "12:00 am" }, // 00:00 hrs
    { id: 1, value: 1, text: "12:30 am" },
    { id: 2, value: 2, text: "1:00 am" },
    { id: 3, value: 3, text: "1:30 am" },
    { id: 4, value: 4, text: "2:00 am" },
    { id: 5, value: 5, text: "2:30 am" },
    { id: 6, value: 6, text: "3:00 am" },
    { id: 7, value: 7, text: "3:30 am" },
    { id: 8, value: 8, text: "4:00 am" },
    { id: 9, value: 9, text: "4:30 am" },
    { id: 10, value: 10, text: "5:00 am" },
    { id: 11, value: 11, text: "5:30 am" },
    { id: 12, value: 12, text: "6:00 am" },
    { id: 13, value: 13, text: "6:30 am" },
    { id: 14, value: 14, text: "7:00 am" },
    { id: 15, value: 15, text: "7:30 am" },
    { id: 16, value: 16, text: "8:00 am" },
    { id: 17, value: 17, text: "8:30 am" },
    { id: 18, value: 18, text: "9:00 am" },
    { id: 19, value: 19, text: "9:30 am" },
    { id: 20, value: 20, text: "10:00 am" },
    { id: 21, value: 21, text: "10:30 am" },
    { id: 22, value: 22, text: "11:00 am" },
    { id: 23, value: 23, text: "11:30 am" },
    { id: 24, value: 24, text: "12:00 pm" }, // 12:00 - noon
    { id: 25, value: 25, text: "12:30 pm" },
    { id: 26, value: 26, text: "1:00 pm" },
    { id: 27, value: 27, text: "1:30 pm" },
    { id: 28, value: 28, text: "2:00 pm" },
    { id: 29, value: 29, text: "2:30 pm" },
    { id: 30, value: 30, text: "3:00 pm" },
    { id: 31, value: 31, text: "3:30 pm" },
    { id: 32, value: 32, text: "4:00 pm" },
    { id: 33, value: 33, text: "4:30 pm" },
    { id: 34, value: 34, text: "5:00 pm" },
    { id: 35, value: 35, text: "5:30 pm" },
    { id: 36, value: 36, text: "6:00 pm" },
    { id: 37, value: 37, text: "6:30 pm" },
    { id: 38, value: 38, text: "7:00 pm" },
    { id: 39, value: 39, text: "7:30 pm" },
    { id: 40, value: 40, text: "8:00 pm" },
    { id: 41, value: 41, text: "8:30 pm" },
    { id: 42, value: 42, text: "9:00 pm" },
    { id: 43, value: 43, text: "9:30 pm" },
    { id: 44, value: 44, text: "10:00 pm" },
    { id: 45, value: 45, text: "10:30 pm" },
    { id: 46, value: 46, text: "11:00 pm" },
    { id: 47, value: 47, text: "11:30 pm" },
  ]),

  staticCities: Object.freeze([
    { text: "La Esmeralda (Municipio Alto Orinoco)", value:
        { stateId: 1, id: 1, name: "La Esmeralda (Municipio Alto Orinoco)", slug: "la-esmeralda" }
    },
    { text: "San Fernando de Atabapo (Municipio Atabapo)", value:
        { stateId: 1, id: 2, name: "San Fernando de Atabapo (Municipio Atabapo)", slug: "san-fernando-de-atabapo" }
    },
    { text: "Puerto Ayacucho (Municipio Atures)", value:
        { stateId: 1, id: 3, name: "Puerto Ayacucho (Municipio Atures)", slug: "puerto-ayacucho" }
    },
    { text: "Isla Ratón (Municipio Autana)", value:
        { stateId: 1, id: 4, name: "Isla Ratón (Municipio Autana)", slug: "isla-raton" }
    },
    { text: "San Juan de Manapiare (Municipio Manapiare)", value:
        { stateId: 1, id: 5, name: "San Juan de Manapiare (Municipio Manapiare)", slug: "san-juan-de-manapiare" }
    },
    { text: "Maroa (Municipio Maroa)", value:
        { stateId: 1, id: 6, name: "Maroa (Municipio Maroa)", slug: "maroa" }
    },
    { text: "San Carlos de Río Negro (Municipio Río Negro)", value:
        { stateId: 1, id: 7, name: "San Carlos de Río Negro (Municipio Río Negro)", slug: "san-carlos-de-rio-negro" }
    },
    { text: "Anaco (Municipio Anaco)", value:
        { stateId: 2, id: 8, name: "Anaco (Municipio Anaco)", slug: "anaco" }
    },
    { text: "Aragua de Barcelona (Municipio Aragua)", value:
        { stateId: 2, id: 9, name: "Aragua de Barcelona (Municipio Aragua)", slug: "aragua-de-barcelona" }
    },
    { text: "Barcelona (Municipio Bolívar)", value:
        { stateId: 2, id: 10, name: "Barcelona (Municipio Bolívar)", slug: "barcelona" }
    },
    { text: "Clarines (Municipio Bruzual)", value:
        { stateId: 2, id: 11, name: "Clarines (Municipio Bruzual)", slug: "clarines" }
    },
    { text: "Onoto (Municipio Cajigal)", value:
        { stateId: 2, id: 12, name: "Onoto (Municipio Cajigal)", slug: "onoto" }
    },
    { text: "Valle de Guanape (Municipio Carvajal)", value:
        { stateId: 2, id: 13, name: "Valle de Guanape (Municipio Carvajal)", slug: "valle-de-guanape" }
    },
    { text: "Lechería (Municipio Diego Bautista Urbaneja)", value:
        { stateId: 2, id: 14, name: "Lechería (Municipio Diego Bautista Urbaneja)", slug: "lecheria" }
    },
    { text: "Cantaura (Municipio Freites)", value:
        { stateId: 2, id: 15, name: "Cantaura (Municipio Freites)", slug: "cantaura" }
    },
    { text: "San José de Guanipa (Municipio Guanipa)", value:
        { stateId: 2, id: 16, name: "San José de Guanipa (Municipio Guanipa)", slug: "san-jose-de-guanipa" }
    },
    { text: "Guanta (Municipio Guanta)", value:
        { stateId: 2, id: 17, name: "Guanta (Municipio Guanta)", slug: "guanta" }
    },
    { text: "Soledad (Municipio Independencia)", value:
        { stateId: 2, id: 18, name: "Soledad (Municipio Independencia)", slug: "soledad" }
    },
    { text: "San Mateo (Municipio Libertad)", value:
        { stateId: 2, id: 19, name: "San Mateo (Municipio Libertad)", slug: "san-mateo" }
    },
    { text: "El Chaparro (Municipio McGregor)", value:
        { stateId: 2, id: 20, name: "El Chaparro (Municipio McGregor)", slug: "el-chaparro" }
    },
    { text: "Pariaguá (Municipio Miranda)", value:
        { stateId: 2, id: 21, name: "Pariaguá (Municipio Miranda)", slug: "pariagua" }
    },
    { text: "San Diego de Cabrutic (Municipio Monagas)", value:
        { stateId: 2, id: 22, name: "San Diego de Cabrutic (Municipio Monagas)", slug: "san-diego-de-cabrutic" }
    },
    { text: "Puerto Pírit (Municipio Peñalver)", value:
        { stateId: 2, id: 23, name: "Puerto Pírit (Municipio Peñalver)", slug: "puerto-pirit" }
    },
    { text: "Píritu (Municipio Píritu)", value:
        { stateId: 2, id: 24, name: "Píritu (Municipio Píritu)", slug: "piritu" }
    },
    { text: "Boca de Uchire (Municipio San Juan de Capistrano)", value:
        { stateId: 2, id: 25, name: "Boca de Uchire (Municipio San Juan de Capistrano)", slug: "boca-de-uchire" }
    },
    { text: "Santa Ana (Municipio Santa Ana)", value:
        { stateId: 2, id: 26, name: "Santa Ana (Municipio Santa Ana)", slug: "santa-ana" }
    },
    { text: "El Tigre (Municipio Simón Rodriguez)", value:
        { stateId: 2, id: 27, name: "El Tigre (Municipio Simón Rodriguez)", slug: "el-tigre" }
    },
    { text: "Puerto La Cruz (Municipio Sotillo)", value:
        { stateId: 2, id: 28, name: "Puerto La Cruz (Municipio Sotillo)", slug: "puerto-la-cruz" }
    },
    { text: "Achaguas (Municipio Achaguas)", value:
        { stateId: 3, id: 29, name: "Achaguas (Municipio Achaguas)", slug: "achaguas" }
    },
    { text: "Biruaca (Municipio Biruaca)", value:
        { stateId: 3, id: 30, name: "Biruaca (Municipio Biruaca)", slug: "biruaca" }
    },
    { text: "Bruzual (Municipio Muñoz)", value:
        { stateId: 3, id: 31, name: "Bruzual (Municipio Muñoz)", slug: "bruzual" }
    },
    { text: "Guasdualito (Municipio Páez)", value:
        { stateId: 3, id: 32, name: "Guasdualito (Municipio Páez)", slug: "guasdualito" }
    },
    { text: "San Juan de Payara (Municipio Pedro Camejo)", value:
        { stateId: 3, id: 33, name: "San Juan de Payara (Municipio Pedro Camejo)", slug: "san-juan-de-payara" }
    },
    { text: "Elorza (Municipio Rómulo Gallegos)", value:
        { stateId: 3, id: 34, name: "Elorza (Municipio Rómulo Gallegos)", slug: "elorza" }
    },
    { text: "San Fernando de Apure (Municipio San Fernando)", value:
        { stateId: 3, id: 35, name: "San Fernando de Apure (Municipio San Fernando)", slug: "san-fernando-de-apure" }
    },
    { text: "San Mateo (Municipio Bolívar)", value:
        { stateId: 4, id: 36, name: "San Mateo (Municipio Bolívar)", slug: "san-mateo" }
    },
    { text: "Camatagua (Municipio Camatagu)", value:
        { stateId: 4, id: 37, name: "Camatagua (Municipio Camatagu)", slug: "camatagua" }
    },
    { text: "Santa Rita (Municipio Francisco Linares Alcántara)", value:
        { stateId: 4, id: 38, name: "Santa Rita (Municipio Francisco Linares Alcántara)", slug: "santa-rita" }
    },
    { text: "Maracay (Municipio Girardot)", value:
        { stateId: 4, id: 39, name: "Maracay (Municipio Girardot)", slug: "maracay" }
    },
    { text: "Santa Cruz (Municipio José Ángel Lamas)", value:
        { stateId: 4, id: 40, name: "Santa Cruz (Municipio José Ángel Lamas)", slug: "santa-cruz" }
    },
    { text: "La Victoria (Municipio José Félix Ribas)", value:
        { stateId: 4, id: 41, name: "La Victoria (Municipio José Félix Ribas)", slug: "la-victoria" }
    },
    { text: "El Consejo (Municipio José Rafael Revenga)", value:
        { stateId: 4, id: 42, name: "El Consejo (Municipio José Rafael Revenga)", slug: "el-consejo" }
    },
    { text: "Palo Negro (Municipio Libertador)", value:
        { stateId: 4, id: 43, name: "Palo Negro (Municipio Libertador)", slug: "palo-negro" }
    },
    { text: "El Limón (Municipio Mario Briceño Iragorry)", value:
        { stateId: 4, id: 44, name: "El Limón (Municipio Mario Briceño Iragorry)", slug: "el-limon" }
    },
    { text: "Ocumare de la Costa (Municipio Ocumare de la Costa de Oro)", value:
        { stateId: 4, id: 45, name: "Ocumare de la Costa (Municipio Ocumare de la Costa de Oro)", slug: "ocumare-de-la-costa" }
    },
    { text: "San Casimiro (Municipio San Casimiro)", value:
        { stateId: 4, id: 46, name: "San Casimiro (Municipio San Casimiro)", slug: "san-casimiro" }
    },
    { text: "San Sebastián de los Reyes (Municipio San Sebastián)", value:
        { stateId: 4, id: 47, name: "San Sebastián de los Reyes (Municipio San Sebastián)", slug: "san-sebastian-de-los-reyes" }
    },
    { text: "Turmero (Municipio Santiago Mariño)", value:
        { stateId: 4, id: 48, name: "Turmero (Municipio Santiago Mariño)", slug: "turmero" }
    },
    { text: "Las Tejerías (Municipio Santos Michelena)", value:
        { stateId: 4, id: 49, name: "Las Tejerías (Municipio Santos Michelena)", slug: "las-tejerias" }
    },
    { text: "Cagua (Municipio Sucre)", value:
        { stateId: 4, id: 50, name: "Cagua (Municipio Sucre)", slug: "cagua" }
    },
    { text: "Colonia Tovar (Municipio Tovar)", value:
        { stateId: 4, id: 51, name: "Colonia Tovar (Municipio Tovar)", slug: "colonia-tovar" }
    },
    { text: "Barbacoas (Municipio Urdaneta)", value:
        { stateId: 4, id: 52, name: "Barbacoas (Municipio Urdaneta)", slug: "barbacoas" }
    },
    { text: "Villa de Cura (Municipio Zamora)", value:
        { stateId: 4, id: 53, name: "Villa de Cura (Municipio Zamora)", slug: "villa-de-cura" }
    },
    { text: "Sabaneta (Municipio Alberto Arvelo Torrealba)", value:
        { stateId: 5, id: 54, name: "Sabaneta (Municipio Alberto Arvelo Torrealba)", slug: "sabaneta" }
    },
    { text: "El Cantón (Municipio Andrés Eloy Blanco)", value:
        { stateId: 5, id: 55, name: "El Cantón (Municipio Andrés Eloy Blanco)", slug: "el-canton" }
    },
    { text: "Socopó (Municipio Antonio José de Sucre)", value:
        { stateId: 5, id: 56, name: "Socopó (Municipio Antonio José de Sucre)", slug: "socopo" }
    },
    { text: "Arismendi (Municipio Arismendi)", value:
        { stateId: 5, id: 57, name: "Arismendi (Municipio Arismendi)", slug: "arismendi" }
    },
    { text: "Barinas (Municipio Barinas)", value:
        { stateId: 5, id: 58, name: "Barinas (Municipio Barinas)", slug: "barinas" }
    },
    { text: "Barinitas (Municipio Bolívar)", value:
        { stateId: 5, id: 59, name: "Barinitas (Municipio Bolívar)", slug: "barinitas" }
    },
    { text: "Barrancas (Municipio Cruz Paredes)", value:
        { stateId: 5, id: 60, name: "Barrancas (Municipio Cruz Paredes)", slug: "barrancas" }
    },
    { text: "Santa Bárbara (Municipio Ezequiel Zamora)", value:
        { stateId: 5, id: 61, name: "Santa Bárbara (Municipio Ezequiel Zamora)", slug: "santa-barbara" }
    },
    { text: "Obispos (Municipio Obispos)", value:
        { stateId: 5, id: 62, name: "Obispos (Municipio Obispos)", slug: "obispos" }
    },
    { text: "Ciudad Bolivia (Municipio Pedraza)", value:
        { stateId: 5, id: 63, name: "Ciudad Bolivia (Municipio Pedraza)", slug: "ciudad-bolivia" }
    },
    { text: "Libertad (Municipio Rojas)", value:
        { stateId: 5, id: 64, name: "Libertad (Municipio Rojas)", slug: "libertad" }
    },
    { text: "Ciudad de Nutrias (Municipio Sosa)", value:
        { stateId: 5, id: 65, name: "Ciudad de Nutrias (Municipio Sosa)", slug: "ciudad-de-nutrias" }
    },
    { text: "Ciudad Guayana (Municipio Caroní)", value:
        { stateId: 6, id: 66, name: "Ciudad Guayana (Municipio Caroní)", slug: "ciudad-guayana" }
    },
    { text: "Caicara del Orinoco (Municipio Cedeño)", value:
        { stateId: 6, id: 67, name: "Caicara del Orinoco (Municipio Cedeño)", slug: "caicara-del-orinoco" }
    },
    { text: "El Callao (Municipio El Callao)", value:
        { stateId: 6, id: 68, name: "El Callao (Municipio El Callao)", slug: "el-callao" }
    },
    { text: "Santa Elena de Uairén (Municipio Gran Sabana)", value:
        { stateId: 6, id: 69, name: "Santa Elena de Uairén (Municipio Gran Sabana)", slug: "santa-elena-de-uairen" }
    },
    { text: "Ciudad Bolívar (Municipio Heres)", value:
        { stateId: 6, id: 70, name: "Ciudad Bolívar (Municipio Heres)", slug: "ciudad-bolivar" }
    },
    { text: "Upata (Municipio Piar)", value:
        { stateId: 6, id: 71, name: "Upata (Municipio Piar)", slug: "upata" }
    },
    { text: "Ciudad Piar (Municipio Raúl Leoni)", value:
        { stateId: 6, id: 72, name: "Ciudad Piar (Municipio Raúl Leoni)", slug: "ciudad-piar" }
    },
    { text: "Guasipati (Municipio Roscio)", value:
        { stateId: 6, id: 73, name: "Guasipati (Municipio Roscio)", slug: "guasipati" }
    },
    { text: "Tumeremo (Municipio Sifontes)", value:
        { stateId: 6, id: 74, name: "Tumeremo (Municipio Sifontes)", slug: "tumeremo" }
    },
    { text: "Maripa (Municipio Sucre)", value:
        { stateId: 6, id: 75, name: "Maripa (Municipio Sucre)", slug: "maripa" }
    },
    { text: "El Palmar (Municipio Padre Pedro Chen)", value:
        { stateId: 6, id: 76, name: "El Palmar (Municipio Padre Pedro Chen)", slug: "el-palmar" }
    },
    { text: "Bejuma (Municipio Bejuma)", value:
        { stateId: 7, id: 77, name: "Bejuma (Municipio Bejuma)", slug: "bejuma" }
    },
    { text: "Güigüe (Municipio Carlos Arvelo)", value:
        { stateId: 7, id: 78, name: "Güigüe (Municipio Carlos Arvelo)", slug: "güigüe" }
    },
    { text: "Mariara (Municipio Diego Ibarra)", value:
        { stateId: 7, id: 79, name: "Mariara (Municipio Diego Ibarra)", slug: "mariara" }
    },
    { text: "Guacara (Municipio Guacara)", value:
        { stateId: 7, id: 80, name: "Guacara (Municipio Guacara)", slug: "guacara" }
    },
    { text: "Morón (Municipio Juan José Mora)", value:
        { stateId: 7, id: 81, name: "Morón (Municipio Juan José Mora)", slug: "moron" }
    },
    { text: "Tocuyito (Municipio Libertador)", value:
        { stateId: 7, id: 82, name: "Tocuyito (Municipio Libertador)", slug: "tocuyito" }
    },
    { text: "Los Guayos (Municipio Los Guayos)", value:
        { stateId: 7, id: 83, name: "Los Guayos (Municipio Los Guayos)", slug: "los-guayos" }
    },
    { text: "Miranda (Municipio Miranda)", value:
        { stateId: 7, id: 84, name: "Miranda (Municipio Miranda)", slug: "miranda" }
    },
    { text: "Montalbán (Municipio Montalbán)", value:
        { stateId: 7, id: 85, name: "Montalbán (Municipio Montalbán)", slug: "montalban" }
    },
    { text: "Naguanagua (Municipio Naguanagua)", value:
        { stateId: 7, id: 86, name: "Naguanagua (Municipio Naguanagua)", slug: "naguanagua" }
    },
    { text: "Puerto Cabello (Municipio Puerto Cabello)", value:
        { stateId: 7, id: 87, name: "Puerto Cabello (Municipio Puerto Cabello)", slug: "puerto-cabello" }
    },
    { text: "San Diego (Municipio San Diego)", value:
        { stateId: 7, id: 88, name: "San Diego (Municipio San Diego)", slug: "san-diego" }
    },
    { text: "San Joaquín (Municipio San Joaquín)", value:
        { stateId: 7, id: 89, name: "San Joaquín (Municipio San Joaquín)", slug: "san-joaquin" }
    },
    { text: "Valencia (Municipio Valencia)", value:
        { stateId: 7, id: 90, name: "Valencia (Municipio Valencia)", slug: "valencia" }
    },
    { text: "Cojedes (Municipio Anzoátegui)", value:
        { stateId: 8, id: 91, name: "Cojedes (Municipio Anzoátegui)", slug: "cojedes" }
    },
    { text: "Tinaquillo (Municipio Falcón)", value:
        { stateId: 8, id: 92, name: "Tinaquillo (Municipio Falcón)", slug: "tinaquillo" }
    },
    { text: "El Baúl (Municipio Girardot)", value:
        { stateId: 8, id: 93, name: "El Baúl (Municipio Girardot)", slug: "el-baul" }
    },
    { text: "Macapo (Municipio Lima Blanco)", value:
        { stateId: 8, id: 94, name: "Macapo (Municipio Lima Blanco)", slug: "macapo" }
    },
    { text: "El Pao (Municipio Pao de San Juan Bautista)", value:
        { stateId: 8, id: 95, name: "El Pao (Municipio Pao de San Juan Bautista)", slug: "el-pao" }
    },
    { text: "Libertad (Municipio Ricaurte)", value:
        { stateId: 8, id: 96, name: "Libertad (Municipio Ricaurte)", slug: "libertad" }
    },
    { text: "Rómulo Gallegos (Municipio Rómulo Gallegos)", value:
        { stateId: 8, id: 97, name: "Rómulo Gallegos (Municipio Rómulo Gallegos)", slug: "romulo-gallegos" }
    },
    { text: "Curiapo (Municipio Antonio Díaz Curiapo)", value:
        { stateId: 9, id: 98, name: "Curiapo (Municipio Antonio Díaz Curiapo)", slug: "curiapo" }
    },
    { text: "Sierra Imataca (Municipio Casacoima)", value:
        { stateId: 9, id: 99, name: "Sierra Imataca (Municipio Casacoima)", slug: "sierra-imataca" }
    },
    { text: "Pedernales (Municipio Pedernales)", value:
        { stateId: 9, id: 100, name: "Pedernales (Municipio Pedernales)", slug: "pedernales" }
    },
    { text: "Tucupita (Municipio Tucupita)", value:
        { stateId: 9, id: 101, name: "Tucupita (Municipio Tucupita)", slug: "tucupita" }
    },
    { text: "Caraca (Municipio Libertador)", value:
        { stateId: 10, id: 102, name: "Caraca (Municipio Libertador)", slug: "caraca" }
    },
    { text: "San Juan de los Cayos (Municipio Acosta)", value:
        { stateId: 11, id: 103, name: "San Juan de los Cayos (Municipio Acosta)", slug: "san-juan-de-los-cayos" }
    },
    { text: "San Luis (Municipio Bolívar)", value:
        { stateId: 11, id: 104, name: "San Luis (Municipio Bolívar)", slug: "san-luis" }
    },
    { text: "Capatárida (Municipio Buchivacoa)", value:
        { stateId: 11, id: 105, name: "Capatárida (Municipio Buchivacoa)", slug: "capatarida" }
    },
    { text: "Yaracal (Municipio Cacique Manaure)", value:
        { stateId: 11, id: 106, name: "Yaracal (Municipio Cacique Manaure)", slug: "yaracal" }
    },
    { text: "Punto Fijo (Municipio Carirubana)", value:
        { stateId: 11, id: 107, name: "Punto Fijo (Municipio Carirubana)", slug: "punto-fijo" }
    },
    { text: "La Vela de Coro (Municipio Colina)", value:
        { stateId: 11, id: 108, name: "La Vela de Coro (Municipio Colina)", slug: "la-vela-de-coro" }
    },
    { text: "Dabajuro (Municipio Dabajuro)", value:
        { stateId: 11, id: 109, name: "Dabajuro (Municipio Dabajuro)", slug: "dabajuro" }
    },
    { text: "Pedregal (Municipio Democracia)", value:
        { stateId: 11, id: 110, name: "Pedregal (Municipio Democracia)", slug: "pedregal" }
    },
    { text: "Pueblo Nuevo (Municipio Falcón)", value:
        { stateId: 11, id: 111, name: "Pueblo Nuevo (Municipio Falcón)", slug: "pueblo-nuevo" }
    },
    { text: "Churuguara (Municipio Federación)", value:
        { stateId: 11, id: 112, name: "Churuguara (Municipio Federación)", slug: "churuguara" }
    },
    { text: "Jacura (Municipio Jacura)", value:
        { stateId: 11, id: 113, name: "Jacura (Municipio Jacura)", slug: "jacura" }
    },
    { text: "Santa Cruz de Los Taques (Municipio Los Taques)", value:
        { stateId: 11, id: 114, name: "Santa Cruz de Los Taques (Municipio Los Taques)", slug: "santa-cruz-de-los-taques" }
    },
    { text: "Mene de Mauroa (Municipio Mauroa)", value:
        { stateId: 11, id: 115, name: "Mene de Mauroa (Municipio Mauroa)", slug: "mene-de-mauroa" }
    },
    { text: "Santa Ana de Coro (Municipio Miranda)", value:
        { stateId: 11, id: 116, name: "Santa Ana de Coro (Municipio Miranda)", slug: "santa-ana-de-coro" }
    },
    { text: "Chichiriviche (Municipio Monseñor Iturriza)", value:
        { stateId: 11, id: 117, name: "Chichiriviche (Municipio Monseñor Iturriza)", slug: "chichiriviche" }
    },
    { text: "Palmasola (Municipio Palmasola)", value:
        { stateId: 11, id: 118, name: "Palmasola (Municipio Palmasola)", slug: "palmasola" }
    },
    { text: "Cabure (Municipio Petit)", value:
        { stateId: 11, id: 119, name: "Cabure (Municipio Petit)", slug: "cabure" }
    },
    { text: "Píritu (Municipio Píritu)", value:
        { stateId: 11, id: 120, name: "Píritu (Municipio Píritu)", slug: "piritu" }
    },
    { text: "Mirimire (Municipio San Francisco)", value:
        { stateId: 11, id: 121, name: "Mirimire (Municipio San Francisco)", slug: "mirimire" }
    },
    { text: "Tucacas (Municipio Silva)", value:
        { stateId: 11, id: 122, name: "Tucacas (Municipio Silva)", slug: "tucacas" }
    },
    { text: "La Cruz de Taratara (Municipio Sucre)", value:
        { stateId: 11, id: 123, name: "La Cruz de Taratara (Municipio Sucre)", slug: "la-cruz-de-taratara" }
    },
    { text: "Tocópero (Municipio Tocópero)", value:
        { stateId: 11, id: 124, name: "Tocópero (Municipio Tocópero)", slug: "tocopero" }
    },
    { text: "Santa Cruz de Bucaral (Municipio Unión)", value:
        { stateId: 11, id: 125, name: "Santa Cruz de Bucaral (Municipio Unión)", slug: "santa-cruz-de-bucaral" }
    },
    { text: "Urumaco (Municipio Urumaco)", value:
        { stateId: 11, id: 126, name: "Urumaco (Municipio Urumaco)", slug: "urumaco" }
    },
    { text: "Puerto Cumarebo (Municipio Zamora)", value:
        { stateId: 11, id: 127, name: "Puerto Cumarebo (Municipio Zamora)", slug: "puerto-cumarebo" }
    },
    { text: "Camagua (Municipio Esteros de Camagua)", value:
        { stateId: 12, id: 128, name: "Camagua (Municipio Esteros de Camagua)", slug: "camagua" }
    },
    { text: "Chaguarama (Municipio Chaguarama)", value:
        { stateId: 12, id: 129, name: "Chaguarama (Municipio Chaguarama)", slug: "chaguarama" }
    },
    { text: "El Socorro (Municipio El Socorro)", value:
        { stateId: 12, id: 130, name: "El Socorro (Municipio El Socorro)", slug: "el-socorro" }
    },
    { text: "Calabozo (Municipio Francisco de Miranda)", value:
        { stateId: 12, id: 131, name: "Calabozo (Municipio Francisco de Miranda)", slug: "calabozo" }
    },
    { text: "Tucupido (Municipio José Félix Ribas)", value:
        { stateId: 12, id: 132, name: "Tucupido (Municipio José Félix Ribas)", slug: "tucupido" }
    },
    { text: "Altagracia de Orituco (Municipio José Tadeo Monagas)", value:
        { stateId: 12, id: 133, name: "Altagracia de Orituco (Municipio José Tadeo Monagas)", slug: "altagracia-de-orituco" }
    },
    { text: "San Juan de Los Morros (Municipio Juan Germán Roscio)", value:
        { stateId: 12, id: 134, name: "San Juan de Los Morros (Municipio Juan Germán Roscio)", slug: "san-juan-de-los-morros" }
    },
    { text: "El Sombrero (Municipio Julián Mellado)", value:
        { stateId: 12, id: 135, name: "El Sombrero (Municipio Julián Mellado)", slug: "el-sombrero" }
    },
    { text: "Las Mercedes (Municipio Las Mercedes)", value:
        { stateId: 12, id: 136, name: "Las Mercedes (Municipio Las Mercedes)", slug: "las-mercedes" }
    },
    { text: "Valle de La Pascua (Municipio Leonardo Infante)", value:
        { stateId: 12, id: 137, name: "Valle de La Pascua (Municipio Leonardo Infante)", slug: "valle-de-la-pascua" }
    },
    { text: "Zaraza (Municipio Pedro Zaraza)", value:
        { stateId: 12, id: 138, name: "Zaraza (Municipio Pedro Zaraza)", slug: "zaraza" }
    },
    { text: "Ortíz (Municipio Ortíz)", value:
        { stateId: 12, id: 139, name: "Ortíz (Municipio Ortíz)", slug: "ortiz" }
    },
    { text: "Guayabal (Municipio San Gerónimo de Guayabal)", value:
        { stateId: 12, id: 140, name: "Guayabal (Municipio San Gerónimo de Guayabal)", slug: "guayabal" }
    },
    { text: "San José de Guaribe (Municipio San José de Guaribe)", value:
        { stateId: 12, id: 141, name: "San José de Guaribe (Municipio San José de Guaribe)", slug: "san-jose-de-guaribe" }
    },
    { text: "Santa María de Ipire (Municipio Santa María de Ipire)", value:
        { stateId: 12, id: 142, name: "Santa María de Ipire (Municipio Santa María de Ipire)", slug: "santa-maria-de-ipire" }
    },
    { text: "Sanare (Municipio Andrés Eloy Blanco)", value:
        { stateId: 13, id: 143, name: "Sanare (Municipio Andrés Eloy Blanco)", slug: "sanare" }
    },
    { text: "Duaca (Municipio Crespo)", value:
        { stateId: 13, id: 144, name: "Duaca (Municipio Crespo)", slug: "duaca" }
    },
    { text: "Barquisimeto (Municipio Iribarren)", value:
        { stateId: 13, id: 145, name: "Barquisimeto (Municipio Iribarren)", slug: "barquisimeto" }
    },
    { text: "Quibor (Municipio Jiménez)", value:
        { stateId: 13, id: 146, name: "Quibor (Municipio Jiménez)", slug: "quibor" }
    },
    { text: "El Tocuyo (Municipio Morán)", value:
        { stateId: 13, id: 147, name: "El Tocuyo (Municipio Morán)", slug: "el-tocuyo" }
    },
    { text: "Cabudare (Municipio Palavecino)", value:
        { stateId: 13, id: 148, name: "Cabudare (Municipio Palavecino)", slug: "cabudare" }
    },
    { text: "Sarare (Municipio Simón Planas)", value:
        { stateId: 13, id: 149, name: "Sarare (Municipio Simón Planas)", slug: "sarare" }
    },
    { text: "Carora (Municipio Torres)", value:
        { stateId: 13, id: 150, name: "Carora (Municipio Torres)", slug: "carora" }
    },
    { text: "Siquisique (Municipio Urdaneta)", value:
        { stateId: 13, id: 151, name: "Siquisique (Municipio Urdaneta)", slug: "siquisique" }
    },
    { text: "El Vigía (Municipio Alberto Adriani)", value:
        { stateId: 14, id: 152, name: "El Vigía (Municipio Alberto Adriani)", slug: "el-vigia" }
    },
    { text: "La Azulita (Municipio Andrés Bello)", value:
        { stateId: 14, id: 153, name: "La Azulita (Municipio Andrés Bello)", slug: "la-azulita" }
    },
    { text: "Santa Cruz de Mora (Municipio Antonio Pinto Salinas)", value:
        { stateId: 14, id: 154, name: "Santa Cruz de Mora (Municipio Antonio Pinto Salinas)", slug: "santa-cruz-de-mora" }
    },
    { text: "Lagunillas (Municipio Sucre)", value:
        { stateId: 14, id: 155, name: "Lagunillas (Municipio Sucre)", slug: "lagunillas" }
    },
    { text: "Tovar (Municipio Tovar)", value:
        { stateId: 14, id: 156, name: "Tovar (Municipio Tovar)", slug: "tovar" }
    },
    { text: "Nueva Bolivia (Municipio Tulio Febres Cordero)", value:
        { stateId: 14, id: 157, name: "Nueva Bolivia (Municipio Tulio Febres Cordero)", slug: "nueva-bolivia" }
    },
    { text: "Zea (Municipio Zea)", value:
        { stateId: 14, id: 158, name: "Zea (Municipio Zea)", slug: "zea" }
    },
    { text: "Caucagua (Municipio Acevedo)", value:
        { stateId: 15, id: 159, name: "Caucagua (Municipio Acevedo)", slug: "caucagua" }
    },
    { text: "San José de Barlovento (Municipio Andrés Bello)", value:
        { stateId: 15, id: 160, name: "San José de Barlovento (Municipio Andrés Bello)", slug: "san-jose-de-barlovento" }
    },
    { text: "Baruta (Municipio Baruta)", value:
        { stateId: 15, id: 161, name: "Baruta (Municipio Baruta)", slug: "baruta" }
    },
    { text: "Higuerote (Municipio Brión)", value:
        { stateId: 15, id: 162, name: "Higuerote (Municipio Brión)", slug: "higuerote" }
    },
    { text: "Mamporal (Municipio Buroz)", value:
        { stateId: 15, id: 163, name: "Mamporal (Municipio Buroz)", slug: "mamporal" }
    },
    { text: "Carrizal (Municipio Carrizal)", value:
        { stateId: 15, id: 164, name: "Carrizal (Municipio Carrizal)", slug: "carrizal" }
    },
    { text: "Chacao (Municipio Chacao)", value:
        { stateId: 15, id: 165, name: "Chacao (Municipio Chacao)", slug: "chacao" }
    },
    { text: "Charallave (Municipio Cristóbal Rojas)", value:
        { stateId: 15, id: 166, name: "Charallave (Municipio Cristóbal Rojas)", slug: "charallave" }
    },
    { text: "El Hatillo (Municipio El Hatillo)", value:
        { stateId: 15, id: 167, name: "El Hatillo (Municipio El Hatillo)", slug: "el-hatillo" }
    },
    { text: "Los Teques (Municipio Guaicaipuro)", value:
        { stateId: 15, id: 168, name: "Los Teques (Municipio Guaicaipuro)", slug: "los-teques" }
    },
    { text: "Santa Teresa del Tuy (Municipio Independencia)", value:
        { stateId: 15, id: 169, name: "Santa Teresa del Tuy (Municipio Independencia)", slug: "santa-teresa-del-tuy" }
    },
    { text: "Ocumare del Tuy (Municipio Lander)", value:
        { stateId: 15, id: 170, name: "Ocumare del Tuy (Municipio Lander)", slug: "ocumare-del-tuy" }
    },
    { text: "San Antonio de los Altos (Municipio Los Salias)", value:
        { stateId: 15, id: 171, name: "San Antonio de los Altos (Municipio Los Salias)", slug: "san-antonio-de-los-altos" }
    },
    { text: "Río Chico (Municipio Páez)", value:
        { stateId: 15, id: 172, name: "Río Chico (Municipio Páez)", slug: "rio-chico" }
    },
    { text: "Santa Lucía (Municipio Paz Castillo)", value:
        { stateId: 15, id: 173, name: "Santa Lucía (Municipio Paz Castillo)", slug: "santa-lucia" }
    },
    { text: "Cúpir (Municipio Pedro Gual)", value:
        { stateId: 15, id: 174, name: "Cúpir (Municipio Pedro Gual)", slug: "cupir" }
    },
    { text: "Guarenas (Municipio Plaza)", value:
        { stateId: 15, id: 175, name: "Guarenas (Municipio Plaza)", slug: "guarenas" }
    },
    { text: "San Francisco de Yare (Municipio Simón Bolívar)", value:
        { stateId: 15, id: 176, name: "San Francisco de Yare (Municipio Simón Bolívar)", slug: "san-francisco-de-yare" }
    },
    { text: "Petare (Municipio Sucre)", value:
        { stateId: 15, id: 177, name: "Petare (Municipio Sucre)", slug: "petare" }
    },
    { text: "Cúa (Municipio Urdaneta)", value:
        { stateId: 15, id: 178, name: "Cúa (Municipio Urdaneta)", slug: "cua" }
    },
    { text: "Guatir (Municipio Zamora)", value:
        { stateId: 15, id: 179, name: "Guatir (Municipio Zamora)", slug: "guatir" }
    },
    { text: "San Antonio de Capayacuar (Municipio Acosta)", value:
        { stateId: 16, id: 180, name: "San Antonio de Capayacuar (Municipio Acosta)", slug: "san-antonio-de-capayacuar" }
    },
    { text: "Aguasai (Municipio Aguasay)", value:
        { stateId: 16, id: 181, name: "Aguasai (Municipio Aguasay)", slug: "aguasai" }
    },
    { text: "Bolíva (Municipio Bolívar)", value:
        { stateId: 16, id: 182, name: "Bolíva (Municipio Bolívar)", slug: "boliva" }
    },
    { text: "Caicara (Municipio Cedeño)", value:
        { stateId: 16, id: 183, name: "Caicara (Municipio Cedeño)", slug: "caicara" }
    },
    { text: "Punta de Mata (Municipio Ezequiel Zamora)", value:
        { stateId: 16, id: 184, name: "Punta de Mata (Municipio Ezequiel Zamora)", slug: "punta-de-mata" }
    },
    { text: "Temblador (Municipio Libertador)", value:
        { stateId: 16, id: 185, name: "Temblador (Municipio Libertador)", slug: "temblador" }
    },
    { text: "Maturín (Municipio Maturín)", value:
        { stateId: 16, id: 186, name: "Maturín (Municipio Maturín)", slug: "maturin" }
    },
    { text: "Aragua (Municipio Piar)", value:
        { stateId: 16, id: 187, name: "Aragua (Municipio Piar)", slug: "aragua" }
    },
    { text: "Quiriquire (Municipio Punceres)", value:
        { stateId: 16, id: 188, name: "Quiriquire (Municipio Punceres)", slug: "quiriquire" }
    },
    { text: "Santa Bárbara (Municipio Santa Bárbara)", value:
        { stateId: 16, id: 189, name: "Santa Bárbara (Municipio Santa Bárbara)", slug: "santa-barbara" }
    },
    { text: "Barrancas del Orinco (Municipio Sotillo)", value:
        { stateId: 16, id: 190, name: "Barrancas del Orinco (Municipio Sotillo)", slug: "barrancas-del-orinco" }
    },
    { text: "Uracoa (Municipio Uracoa)", value:
        { stateId: 16, id: 191, name: "Uracoa (Municipio Uracoa)", slug: "uracoa" }
    },
    { text: "La Plaza de Paraguachí (Municipio Antolín del Campo)", value:
        { stateId: 17, id: 192, name: "La Plaza de Paraguachí (Municipio Antolín del Campo)", slug: "la-plaza-de-paraguachi" }
    },
    { text: "La Asunción (Municipio Arismendi)", value:
        { stateId: 17, id: 193, name: "La Asunción (Municipio Arismendi)", slug: "la-asuncion" }
    },
    { text: "San Juan Bautista (Municipio Díaz)", value:
        { stateId: 17, id: 194, name: "San Juan Bautista (Municipio Díaz)", slug: "san-juan-bautista" }
    },
    { text: "El Valle del Espíritu Santo (Municipio García)", value:
        { stateId: 17, id: 195, name: "El Valle del Espíritu Santo (Municipio García)", slug: "el-valle-del-espiritu-santo" }
    },
    { text: "Santa Ana (Municipio Gómez)", value:
        { stateId: 17, id: 196, name: "Santa Ana (Municipio Gómez)", slug: "santa-ana" }
    },
    { text: "Pampatar (Municipio Maneiro)", value:
        { stateId: 17, id: 197, name: "Pampatar (Municipio Maneiro)", slug: "pampatar" }
    },
    { text: "Juan Griego (Municipio Marcano)", value:
        { stateId: 17, id: 198, name: "Juan Griego (Municipio Marcano)", slug: "juan-griego" }
    },
    { text: "Porlamar (Municipio Mariño)", value:
        { stateId: 17, id: 199, name: "Porlamar (Municipio Mariño)", slug: "porlamar" }
    },
    { text: "Boca de Río (Municipio Península de Macanao)", value:
        { stateId: 17, id: 200, name: "Boca de Río (Municipio Península de Macanao)", slug: "boca-de-rio" }
    },
    { text: "Punta de Piedras (Municipio Tubores)", value:
        { stateId: 17, id: 201, name: "Punta de Piedras (Municipio Tubores)", slug: "punta-de-piedras" }
    },
    { text: "San Pedro de Coche (Municipio Villalba)", value:
        { stateId: 17, id: 202, name: "San Pedro de Coche (Municipio Villalba)", slug: "san-pedro-de-coche" }
    },
    { text: "Agua Blanca (Municipio Agua Blanca)", value:
        { stateId: 18, id: 203, name: "Agua Blanca (Municipio Agua Blanca)", slug: "agua-blanca" }
    },
    { text: "Araure (Municipio Araure)", value:
        { stateId: 18, id: 204, name: "Araure (Municipio Araure)", slug: "araure" }
    },
    { text: "Píritu (Municipio Esteller)", value:
        { stateId: 18, id: 205, name: "Píritu (Municipio Esteller)", slug: "piritu" }
    },
    { text: "Guanare (Municipio Guanare)", value:
        { stateId: 18, id: 206, name: "Guanare (Municipio Guanare)", slug: "guanare" }
    },
    { text: "Guanarito (Municipio Guanarito)", value:
        { stateId: 18, id: 207, name: "Guanarito (Municipio Guanarito)", slug: "guanarito" }
    },
    { text: "Chabasquén de Unda (Municipio Monseñor José Vicenti de Unda)", value:
        { stateId: 18, id: 208, name: "Chabasquén de Unda (Municipio Monseñor José Vicenti de Unda)", slug: "chabasquen-de-unda" }
    },
    { text: "Ospino (Municipio Ospino)", value:
        { stateId: 18, id: 209, name: "Ospino (Municipio Ospino)", slug: "ospino" }
    },
    { text: "Acarigua (Municipio Páez)", value:
        { stateId: 18, id: 210, name: "Acarigua (Municipio Páez)", slug: "acarigua" }
    },
    { text: "Papelón (Municipio Papelón)", value:
        { stateId: 18, id: 211, name: "Papelón (Municipio Papelón)", slug: "papelon" }
    },
    { text: "Boconoíto (Municipio San Genaro de Boconoíto)", value:
        { stateId: 18, id: 212, name: "Boconoíto (Municipio San Genaro de Boconoíto)", slug: "boconoito" }
    },
    { text: "San Rafael de Onoto (Municipio San Rafael de Onoto)", value:
        { stateId: 18, id: 213, name: "San Rafael de Onoto (Municipio San Rafael de Onoto)", slug: "san-rafael-de-onoto" }
    },
    { text: "El Playón (Municipio Santa Rosalía)", value:
        { stateId: 18, id: 214, name: "El Playón (Municipio Santa Rosalía)", slug: "el-playon" }
    },
    { text: "Biscucuy (Municipio Sucre)", value:
        { stateId: 18, id: 215, name: "Biscucuy (Municipio Sucre)", slug: "biscucuy" }
    },
    { text: "Villa Bruzual (Municipio Turén)", value:
        { stateId: 18, id: 216, name: "Villa Bruzual (Municipio Turén)", slug: "villa-bruzual" }
    },
    { text: "Casanay (Municipio Andrés Eloy Blanco)", value:
        { stateId: 19, id: 217, name: "Casanay (Municipio Andrés Eloy Blanco)", slug: "casanay" }
    },
    { text: "San José de Aerocuar (Municipio Andrés Mata)", value:
        { stateId: 19, id: 218, name: "San José de Aerocuar (Municipio Andrés Mata)", slug: "san-jose-de-aerocuar" }
    },
    { text: "Río Caribe (Municipio Arismendi)", value:
        { stateId: 19, id: 219, name: "Río Caribe (Municipio Arismendi)", slug: "rio-caribe" }
    },
    { text: "El Pilar (Municipio Benítez)", value:
        { stateId: 19, id: 220, name: "El Pilar (Municipio Benítez)", slug: "el-pilar" }
    },
    { text: "Carúpano (Municipio Bermúdez)", value:
        { stateId: 19, id: 221, name: "Carúpano (Municipio Bermúdez)", slug: "carupano" }
    },
    { text: "Marigüitar (Municipio Bolívar)", value:
        { stateId: 19, id: 222, name: "Marigüitar (Municipio Bolívar)", slug: "marigüitar" }
    },
    { text: "Yaguaraparo (Municipio Cajigal)", value:
        { stateId: 19, id: 223, name: "Yaguaraparo (Municipio Cajigal)", slug: "yaguaraparo" }
    },
    { text: "Araya (Municipio Cruz Salmerón Acosta)", value:
        { stateId: 19, id: 224, name: "Araya (Municipio Cruz Salmerón Acosta)", slug: "araya" }
    },
    { text: "Tunapuy (Municipio Libertador)", value:
        { stateId: 19, id: 225, name: "Tunapuy (Municipio Libertador)", slug: "tunapuy" }
    },
    { text: "Irapa (Municipio Mariño)", value:
        { stateId: 19, id: 226, name: "Irapa (Municipio Mariño)", slug: "irapa" }
    },
    { text: "San Antonio del Golfo (Municipio Mejía)", value:
        { stateId: 19, id: 227, name: "San Antonio del Golfo (Municipio Mejía)", slug: "san-antonio-del-golfo" }
    },
    { text: "Cumanacoa (Municipio Montes)", value:
        { stateId: 19, id: 228, name: "Cumanacoa (Municipio Montes)", slug: "cumanacoa" }
    },
    { text: "Cariaco (Municipio Ribero)", value:
        { stateId: 19, id: 229, name: "Cariaco (Municipio Ribero)", slug: "cariaco" }
    },
    { text: "Cumaná (Municipio Sucre)", value:
        { stateId: 19, id: 230, name: "Cumaná (Municipio Sucre)", slug: "cumana" }
    },
    { text: "Güiria (Municipio Valdez)", value:
        { stateId: 19, id: 231, name: "Güiria (Municipio Valdez)", slug: "güiria" }
    },
    { text: "Cordero (Municipio Andrés Bell)", value:
        { stateId: 20, id: 232, name: "Cordero (Municipio Andrés Bell)", slug: "cordero" }
    },
    { text: "Las Mesas (Municipio Antonio Rómulo Costa)", value:
        { stateId: 20, id: 233, name: "Las Mesas (Municipio Antonio Rómulo Costa)", slug: "las-mesas" }
    },
    { text: "El Colón (Municipio Ayacucho)", value:
        { stateId: 20, id: 234, name: "El Colón (Municipio Ayacucho)", slug: "el-colon" }
    },
    { text: "San Antonio del Táchira (Municipio Bolívar)", value:
        { stateId: 20, id: 235, name: "San Antonio del Táchira (Municipio Bolívar)", slug: "san-antonio-del-tachira" }
    },
    { text: "Táriba (Municipio Cárdenas)", value:
        { stateId: 20, id: 236, name: "Táriba (Municipio Cárdenas)", slug: "tariba" }
    },
    { text: "Santa Ana de Táchira (Municipio Córdoba)", value:
        { stateId: 20, id: 237, name: "Santa Ana de Táchira (Municipio Córdoba)", slug: "santa-ana-de-tachira" }
    },
    { text: "San Rafael del Piñal (Municipio Fernández Feo)", value:
        { stateId: 20, id: 238, name: "San Rafael del Piñal (Municipio Fernández Feo)", slug: "san-rafael-del-pinal" }
    },
    { text: "San José de Bolívar (Municipio Francisco de Miranda)", value:
        { stateId: 20, id: 239, name: "San José de Bolívar (Municipio Francisco de Miranda)", slug: "san-jose-de-bolivar" }
    },
    { text: "La Fría (Municipio García de Hevia)", value:
        { stateId: 20, id: 240, name: "La Fría (Municipio García de Hevia)", slug: "la-fria" }
    },
    { text: "Palmira (Municipio Guásimos)", value:
        { stateId: 20, id: 241, name: "Palmira (Municipio Guásimos)", slug: "palmira" }
    },
    { text: "Capacho Nuevo (Municipio Independencia)", value:
        { stateId: 20, id: 242, name: "Capacho Nuevo (Municipio Independencia)", slug: "capacho-nuevo" }
    },
    { text: "La Grita (Jáuregui)", value:
        { stateId: 20, id: 243, name: "La Grita (Jáuregui)", slug: "la-grita" }
    },
    { text: "El Cobre (José María Vargas)", value:
        { stateId: 20, id: 244, name: "El Cobre (José María Vargas)", slug: "el-cobre" }
    },
    { text: "Rubio (Junín)", value:
        { stateId: 20, id: 245, name: "Rubio (Junín)", slug: "rubio" }
    },
    { text: "Umuquena (San Judas Tadeo)", value:
        { stateId: 20, id: 246, name: "Umuquena (San Judas Tadeo)", slug: "umuquena" }
    },
    { text: "Capacho Viejo (Libertad)", value:
        { stateId: 20, id: 247, name: "Capacho Viejo (Libertad)", slug: "capacho-viejo" }
    },
    { text: "Abejales (Libertador)", value:
        { stateId: 20, id: 248, name: "Abejales (Libertador)", slug: "abejales" }
    },
    { text: "Lobatera (Lobatera)", value:
        { stateId: 20, id: 249, name: "Lobatera (Lobatera)", slug: "lobatera" }
    },
    { text: "Michelena (Michelena)", value:
        { stateId: 20, id: 250, name: "Michelena (Michelena)", slug: "michelena" }
    },
    { text: "Coloncito (Panamericano)", value:
        { stateId: 20, id: 251, name: "Coloncito (Panamericano)", slug: "coloncito" }
    },
    { text: "Ureña (Pedro María Ureña)", value:
        { stateId: 20, id: 252, name: "Ureña (Pedro María Ureña)", slug: "urena" }
    },
    { text: "Delicias (Rafael Urdaneta)", value:
        { stateId: 20, id: 253, name: "Delicias (Rafael Urdaneta)", slug: "delicias" }
    },
    { text: "La Tendida (Samuel Dario Maldonado)", value:
        { stateId: 20, id: 254, name: "La Tendida (Samuel Dario Maldonado)", slug: "la-tendida" }
    },
    { text: "San Cristóbal (San Cristóbal)", value:
        { stateId: 20, id: 255, name: "San Cristóbal (San Cristóbal)", slug: "san-cristobal" }
    },
    { text: "Seboruco (Seboruco)", value:
        { stateId: 20, id: 256, name: "Seboruco (Seboruco)", slug: "seboruco" }
    },
    { text: "San Simon (Simón Rodríguez)", value:
        { stateId: 20, id: 257, name: "San Simon (Simón Rodríguez)", slug: "san-simon" }
    },
    { text: "Queniquea (Sucre)", value:
        { stateId: 20, id: 258, name: "Queniquea (Sucre)", slug: "queniquea" }
    },
    { text: "San Josesito (Torbes)", value:
        { stateId: 20, id: 259, name: "San Josesito (Torbes)", slug: "san-josesito" }
    },
    { text: "Pregonero (Uribante)", value:
        { stateId: 20, id: 260, name: "Pregonero (Uribante)", slug: "pregonero" }
    },
    { text: "Santa Isabel (Municipio Andrés Bello)", value:
        { stateId: 21, id: 261, name: "Santa Isabel (Municipio Andrés Bello)", slug: "santa-isabel" }
    },
    { text: "Boconó (Municipio Boconó)", value:
        { stateId: 21, id: 262, name: "Boconó (Municipio Boconó)", slug: "bocono" }
    },
    { text: "Sabana Grande (Municipio Bolívar)", value:
        { stateId: 21, id: 263, name: "Sabana Grande (Municipio Bolívar)", slug: "sabana-grande" }
    },
    { text: "Chejendé (Municipio Candelaria)", value:
        { stateId: 21, id: 264, name: "Chejendé (Municipio Candelaria)", slug: "chejende" }
    },
    { text: "Carache (Municipio Carache)", value:
        { stateId: 21, id: 265, name: "Carache (Municipio Carache)", slug: "carache" }
    },
    { text: "Escuque (Municipio Escuque)", value:
        { stateId: 21, id: 266, name: "Escuque (Municipio Escuque)", slug: "escuque" }
    },
    { text: "El Paradero (Municipio José Felipe Márquez Cañizalez)", value:
        { stateId: 21, id: 267, name: "El Paradero (Municipio José Felipe Márquez Cañizalez)", slug: "el-paradero" }
    },
    { text: "Campo Elías (Municipio Juan Vicente Campos Elías)", value:
        { stateId: 21, id: 268, name: "Campo Elías (Municipio Juan Vicente Campos Elías)", slug: "campo-elias" }
    },
    { text: "Santa Apolonia (Municipio La Ceiba)", value:
        { stateId: 21, id: 269, name: "Santa Apolonia (Municipio La Ceiba)", slug: "santa-apolonia" }
    },
    { text: "El Dividive (Municipio Miranda)", value:
        { stateId: 21, id: 270, name: "El Dividive (Municipio Miranda)", slug: "el-dividive" }
    },
    { text: "Pampá (Municipio Pampán)", value:
        { stateId: 21, id: 271, name: "Pampá (Municipio Pampán)", slug: "pampa" }
    },
    { text: "Trujill (Municipio Trujillo)", value:
        { stateId: 21, id: 272, name: "Trujill (Municipio Trujillo)", slug: "trujill" }
    },
    { text: "San Lazar (Municipio Andres Linares)", value:
        { stateId: 21, id: 273, name: "San Lazar (Municipio Andres Linares)", slug: "san-lazar" }
    },
    { text: "Pampanit (Municipio Pampanito)", value:
        { stateId: 21, id: 274, name: "Pampanit (Municipio Pampanito)", slug: "pampanit" }
    },
    { text: "La Guaira (Municipio Vargas)", value:
        { stateId: 22, id: 275, name: "La Guaira (Municipio Vargas)", slug: "la-guaira" }
    },
    { text: "San Pablo (Municipio Arístides Bastidas)", value:
        { stateId: 23, id: 276, name: "San Pablo (Municipio Arístides Bastidas)", slug: "san-pablo" }
    },
    { text: "Aroa (Municipio Bolívar)", value:
        { stateId: 23, id: 277, name: "Aroa (Municipio Bolívar)", slug: "aroa" }
    },
    { text: "Chivacoa (Municipio Bruzual)", value:
        { stateId: 23, id: 278, name: "Chivacoa (Municipio Bruzual)", slug: "chivacoa" }
    },
    { text: "Cocorote (Municipio Cocorote)", value:
        { stateId: 23, id: 279, name: "Cocorote (Municipio Cocorote)", slug: "cocorote" }
    },
    { text: "Independencia (Municipio Independencia)", value:
        { stateId: 23, id: 280, name: "Independencia (Municipio Independencia)", slug: "independencia" }
    },
    { text: "El Toro (Municipio Almirante Padilla)", value:
        { stateId: 24, id: 281, name: "El Toro (Municipio Almirante Padilla)", slug: "el-toro" }
    },
    { text: "San Timoteo (Municipio Baralt)", value:
        { stateId: 24, id: 282, name: "San Timoteo (Municipio Baralt)", slug: "san-timoteo" }
    },
    { text: "Cabimas (Municipio Cabimas)", value:
        { stateId: 24, id: 283, name: "Cabimas (Municipio Cabimas)", slug: "cabimas" }
    },
    { text: "Encontrados (Municipio Catatumbo)", value:
        { stateId: 24, id: 284, name: "Encontrados (Municipio Catatumbo)", slug: "encontrados" }
    },
    { text: "San Carlos del Zulia (Municipio Colón)", value:
        { stateId: 24, id: 285, name: "San Carlos del Zulia (Municipio Colón)", slug: "san-carlos-del-zulia" }
    },
    { text: "Pueblo Nuevo-El Chivo (Municipio Francisco Javier Pulgar)", value:
        { stateId: 24, id: 286, name: "Pueblo Nuevo-El Chivo (Municipio Francisco Javier Pulgar)", slug: "pueblo-nuevo-el-chivo" }
    },
    { text: "La Concepción (Municipio Jesús Enrique Losada)", value:
        { stateId: 24, id: 287, name: "La Concepción (Municipio Jesús Enrique Losada)", slug: "la-concepcion" }
    },
    { text: "Casigua El Cubo (Municipio Jesús María Semprún)", value:
        { stateId: 24, id: 288, name: "Casigua El Cubo (Municipio Jesús María Semprún)", slug: "casigua-el-cubo" }
    }
  ]),

  staticStates: Object.freeze([
    { text: "Selecciona un Estado", value: null },
    { text: "Amazonas", value: { id: 1, name: "Amazonas", slug: "amazonas" } },
    { text: "Anzoategui", value: { id: 2, name: "Anzoategui", slug: "anzoategui" } },
    { text: "Apure", value: { id: 3, name: "Apure", slug: "apure" } },
    { text: "Aragua", value: { id: 4, name: "Aragua", slug: "aragua" } },
    { text: "Barinas", value: { id: 5, name: "Barinas", slug: "barinas" } },
    { text: "Bolívar", value: { id: 6, name: "Bolívar", slug: "bolivar" } },
    { text: "Carabobo", value: { id: 7, name: "Carabobo", slug: "carabobo" } },
    { text: "Cojedes", value: { id: 8, name: "Cojedes", slug: "cojedes" } },
    { text: "Delta Amacuro", value: { id: 9, name: "Delta Amacuro", slug: "delta-amacuro" } },
    { text: "Distrito Capital", value: { id: 10, name: "Distrito Capital", slug: "distrito-capital" } },
    { text: "Falcón", value: { id: 11, name: "Falcón", slug: "falcon" } },
    { text: "Guárico", value: { id: 12, name: "Guárico", slug: "guarico" } },
    { text: "Lara", value: { id: 13, name: "Lara", slug: "lara" } },
    { text: "Mérida", value: { id: 14, name: "Mérida", slug: "merida" } },
    { text: "Miranda", value: { id: 15, name: "Miranda", slug: "miranda" } },
    { text: "Monagas", value: { id: 16, name: "Monagas", slug: "monagas" } },
    { text: "Nueva Esparta", value: { id: 17, name: "Nueva Esparta", slug: "nueva-esparta" } },
    { text: "Portuguesa", value: { id: 18, name: "Portuguesa", slug: "portuguesa" } },
    { text: "Sucre", value: { id: 19, name: "Sucre", slug: "sucre" } },
    { text: "Táchira", value: { id: 20, name: "Táchira", slug: "tachira" } },
    { text: "Trujillo", value: { id: 21, name: "Trujillo", slug: "trujillo" } },
    { text: "Yaracuy", value: { id: 22, name: "Yaracuy", slug: "yaracuy" } },
    { text: "Zulia", value: { id: 23, name: "Zulia", slug: "zulia" } }
  ]),

  staticCategories: Object.freeze([
    { id: 1, iconUrl:"https://static.buscameaqui.com/site/categories/ferre1-01.png", name: "Ferretería", short: "Ferreteria", slug: "ferreteria" },
    { id: 2, iconUrl:"https://static.buscameaqui.com/site/categories/repuestos-01.png", name: "Repuestos y Talleres", short: "Repuestos", slug: "repuestos" },
    { id: 3, iconUrl:"https://static.buscameaqui.com/site/categories/mercados-01.png", name: "Mercados y Panaderías", short: "Mercados", slug: "mercados" },
    { id: 4, iconUrl:"https://static.buscameaqui.com/site/categories/salud-01.png", name: "Salud", short: "Salud", slug: "salud" },
    { id: 5, iconUrl:"https://static.buscameaqui.com/site/categories/belleza-01.png", name: "Belleza", short: "Belleza", slug: "belleza" },
    { id: 6, iconUrl:"https://static.buscameaqui.com/site/categories/restaurantes-01.png", name: "Restaurantes", short: "Restaurantes", slug: "restaurantes" },
    { id: 7, iconUrl:"https://static.buscameaqui.com/site/categories/tecnologia-01.png", name: "Tecnología", short: "Tecnologia", slug: "tecnologia" },
    { id: 8, iconUrl:"https://static.buscameaqui.com/site/categories/servicios-01.png", name: "Servicios", short: "Servicios", slug: "servicios" },
    { id: 9, iconUrl:"https://static.buscameaqui.com/site/categories/mascotas-01.png", name: "Mascotas", short: "Mascotas", slug: "mascotas" },
    { id: 10, iconUrl:"https://static.buscameaqui.com/site/categories/entretenimiento-01.png", name: "Entretenimiento", short: "Entretenimiento", slug: "entretenimiento" },
    { id: 11, iconUrl:"https://static.buscameaqui.com/site/categories/educacion-01.png", name: "Educación", short: "Educación", slug: "educacion" },
    { id: 12, iconUrl:"https://static.buscameaqui.com/site/categories/concesionarios-01.png", name: "Concesionarios e Inmobiliarias", short: "Propiedades", slug: "concesionarios-e-inmobiliarias" },
    { id: 13, iconUrl:"https://static.buscameaqui.com/site/categories/domicilios-01.png", name: "Domicilios / Envíos", short: "Domicilios", slug: "domicilios-envios" },
    { id: 14, iconUrl:"https://static.buscameaqui.com/site/categories/licoreria-01.png", name: "Licorerías", short: "Licorerias", slug: "licorerias" },
    { id: 15, iconUrl:"https://static.buscameaqui.com/site/categories/deportes-01.png", name: "Deportes", short: "Deportes", slug: "deportes" },
    { id: 16, iconUrl:"https://static.buscameaqui.com/site/categories/infantil-01.png", name: "Infantil", short: "Infantil", slug: "infantil" }
  ]),
}
